export default "__VITE_ASSET__C7e8x7HG__"